import { ActionType } from 'typesafe-actions';
import {
  setRaceTrackSelectionAction,
  setSelectionAction,
  setSelectionOnRaceTrackAction,
} from '../actions';
import { IRoundState, RoundStates } from '../../RoundStates/types';
import { put, select } from 'redux-saga/effects';
import { roundStateSelector } from '../../RoundStates';
import { betsAreaSelector } from '../selectors';
import { BetsTypes, racetrackSets, sideBets } from 'widgets/Roulette/const';
import { getStraightSelectorsWithNeighbours } from 'widgets/Roulette/helpers';

export function* setRaceTrackSelectionSaga({
  payload,
}: ActionType<typeof setRaceTrackSelectionAction>) {
  const roundState: IRoundState['roundState'] = yield select(roundStateSelector);

  if (!payload || roundState !== RoundStates.BettingTimeStarted) {
    yield put(setSelectionAction(null));
    yield put(setSelectionOnRaceTrackAction(null));
    return;
  }
  const { neighboursCount } = yield select(betsAreaSelector);
  const { type } = payload;

  if (type === BetsTypes.raceTrackStraight) {
    const betsWithNeighbours = getStraightSelectorsWithNeighbours(payload, neighboursCount);
    yield put(setSelectionAction({ bets: betsWithNeighbours }));
    yield put(setSelectionOnRaceTrackAction(betsWithNeighbours));
  }

  if (sideBets.has(type)) {
    const betsWithNeighbours = getStraightSelectorsWithNeighbours(payload, neighboursCount, [
      // @ts-ignore
      ...racetrackSets[type],
    ]);
    const selectionBets = [
      { selector: payload.selector, key: payload.selector.toString() },
      ...betsWithNeighbours,
    ];
    yield put(setSelectionAction({ bets: selectionBets }));
    yield put(setSelectionOnRaceTrackAction(selectionBets));
  }
}
